import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "web-orders-view" }
const _hoisted_2 = { class: "web-orders-view__header" }
const _hoisted_3 = { class: "web-orders-view__content" }
const _hoisted_4 = { class: "web-orders-view__tables" }
const _hoisted_5 = { class: "tables__table-header" }
const _hoisted_6 = { class: "main-table" }
const _hoisted_7 = { class: "tables__main-table" }
const _hoisted_8 = { class: "main-table" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "tables__pagination-buttons" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "web-orders-view__footer" }
const _hoisted_16 = { class: "metrics" }
const _hoisted_17 = { class: "aliceblue fira" }
const _hoisted_18 = { class: "aliceblue fira" }
const _hoisted_19 = { class: "webOrder__header" }
const _hoisted_20 = { class: "semi-large" }
const _hoisted_21 = { class: "webOrder__info" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "webOrder__items-table" }
const _hoisted_27 = { class: "items-table" }
const _hoisted_28 = { class: "secondary-text" }
const _hoisted_29 = { class: "webOrder__actions" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = ["disabled"]

import AcumaticaLoginModal from '@/components/modals/AcumaticaLoginModal.vue';
import { createSalesOrder, loginToAcumatica } from '@/services/mintechAPI';
import { useWebOrderManager } from '@/services/webOrderManager';
import { SalesOrder } from '@/types/salesOrder';
import { useFormatters } from '@/util/formatters';
import { onMounted, Ref, ref, watch } from 'vue';

//--------------------------------------------------
// Service Initialization
//--------------------------------------------------

export default /*@__PURE__*/_defineComponent({
  __name: 'WebOrdersView',
  setup(__props) {

const wom = useWebOrderManager();
const { formatCurrency } = useFormatters();

//--------------------------------------------------
// Reactive State
//--------------------------------------------------
const baid: Ref<string> = ref('');
const poNumber: Ref<string> = ref('');
const salesOrderDescription: Ref<string> = ref('');

const isUIBusy: Ref<boolean> = ref(false);

const displayLoginForm: Ref<boolean> = ref(false);
const loginOperation: Ref<'ready' | 'active' | 'failed'> = ref('ready');

function closeSlideOutModal() {
	if (isUIBusy.value) return;
	wom.clearSelectedWebOrder();
}

function closeLoginForm() {
	if (isUIBusy.value) return;
	displayLoginForm.value = false;
	loginOperation.value = 'ready';
}

//--------------------------------------------------
// Create Sales Order
//--------------------------------------------------
async function createSO() {
	isUIBusy.value = false;
	displayLoginForm.value = false;

	if (!wom.selectedWebOrder.value) return;

	if (!baid.value || !poNumber.value) {
		alert("'BAID' and 'PO Number' cannot be empty");
	}

	isUIBusy.value = true;

	const salesOrder: SalesOrder = {
		baid: baid.value,
		poNumber: poNumber.value,
		description: salesOrderDescription.value,
		items: wom.selectedWebOrder.value.lineItems
	};

	try {
		const { salesOrderCreated, userVerified } = await createSalesOrder(salesOrder);
		if (salesOrderCreated) {
			alert('Sales Order Created');
			return;
		} else if (userVerified && !salesOrderCreated) {
			alert('Request cannot be processed: sales order creation failed');
			return;
		} else if (!userVerified) {
			alert('Acumatica session invalid. Please re-authenticate.');
			displayLoginForm.value = true;
		}
	} catch {
		alert('Error creating sales order');
	} finally {
		isUIBusy.value = false;
	}
}

//--------------------------------------------------
// Login To Acumatica
//--------------------------------------------------
async function loginToAC(username: string, password: string) {
	isUIBusy.value = false;
	loginOperation.value = 'ready';

	if (!username || !password) {
		alert('Request cannot be processed: missing username or password.');
		return;
	}

	try {
		isUIBusy.value = true;
		loginOperation.value = 'active';
		const loginSuccess = await loginToAcumatica(username, password);

		if (loginSuccess) {
			alert('Sucess! Try creating the sales order again.');
			closeLoginForm();
		} else {
			alert('Failed! Please check your credentials and try again');
			loginOperation.value = 'failed';
		}
	} catch {
		alert('Request cannot be processed: network error');
	} finally {
		isUIBusy.value = false;
	}
}

//--------------------------------------------------
// Watchers
//--------------------------------------------------
watch(
	() => wom.selectedWebOrder.value,
	(newValue) => {
		if (!newValue) {
			salesOrderDescription.value = '';
			baid.value = '';
			poNumber.value = '';
			return;
		}
		salesOrderDescription.value = `WebOrder${newValue.id}`;
	}
);

//--------------------------------------------------
// Life Cycle Hooks
//--------------------------------------------------
onMounted(async () => {
	await wom.fetchWebOrders();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "header__titles" }, [
          _createElementVNode("h1", { class: "fira aliceblue" }, "Web Orders"),
          _createElementVNode("p", { class: "fira aliceblue semi-large" }, "Shopify Web Orders")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(wom).searchQuery.value) = $event)),
          placeholder: "Search..."
        }, null, 512), [
          [_vModelText, _unref(wom).searchQuery.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("table", _hoisted_6, [
              _cache[14] || (_cache[14] = _createElementVNode("colgroup", null, [
                _createElementVNode("col", { style: {"width":"75px"} }),
                _createElementVNode("col", { style: {"min-width":"200px","width":"auto"} }),
                _createElementVNode("col", { style: {"width":"200px"} }),
                _createElementVNode("col", { style: {"width":"200px"} }),
                _createElementVNode("col", { style: {"width":"200px"} }),
                _createElementVNode("col", { style: {"width":"200px"} })
              ], -1)),
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wom).tableHeadings, (heading) => {
                    return (_openBlock(), _createElementBlock("th", { key: heading }, _toDisplayString(heading), 1))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _cache[15] || (_cache[15] = _createElementVNode("colgroup", null, [
                _createElementVNode("col", { style: {"width":"75px"} }),
                _createElementVNode("col", { style: {"width":"auto"} }),
                _createElementVNode("col", { style: {"width":"200px"} }),
                _createElementVNode("col", { style: {"width":"200px"} }),
                _createElementVNode("col", { style: {"width":"200px"} }),
                _createElementVNode("col", { style: {"width":"200px"} })
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wom).rowData.value, (row) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: row[0],
                    class: _normalizeClass({ selected: row[0] === _unref(wom).selectedWebOrderId.value }),
                    onClick: ($event: any) => (_unref(wom).selectWebOrder(row[0]))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: cell[0]
                      }, _toDisplayString(cell), 1))
                    }), 128))
                  ], 10, _hoisted_9))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "icon-button",
              disabled: _unref(wom).isFirstPage.value,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(wom).firstPage()))
            }, [...(_cache[16] || (_cache[16] = [
              _createElementVNode("span", { class: "material-symbols-outlined" }, "first_page", -1)
            ]))], 8, _hoisted_11),
            _createElementVNode("button", {
              class: "icon-button",
              disabled: _unref(wom).isFirstPage.value,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(wom).prevPage()))
            }, [...(_cache[17] || (_cache[17] = [
              _createElementVNode("span", { class: "material-symbols-outlined" }, "chevron_left", -1)
            ]))], 8, _hoisted_12),
            _createElementVNode("p", null, _toDisplayString(_unref(wom).totalItems.value ? _unref(wom).pageStartIndex.value + 1 : 0) + " - " + _toDisplayString(_unref(wom).pageEndIndex.value) + " of " + _toDisplayString(_unref(wom).totalItems.value), 1),
            _createElementVNode("button", {
              class: "icon-button",
              disabled: _unref(wom).isLastPage.value,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(wom).nextPage()))
            }, [...(_cache[18] || (_cache[18] = [
              _createElementVNode("span", { class: "material-symbols-outlined" }, "chevron_right", -1)
            ]))], 8, _hoisted_13),
            _createElementVNode("button", {
              class: "icon-button",
              disabled: _unref(wom).isLastPage.value,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(wom).lastPage()))
            }, [...(_cache[19] || (_cache[19] = [
              _createElementVNode("span", { class: "material-symbols-outlined" }, "last_page", -1)
            ]))], 8, _hoisted_14)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("p", _hoisted_17, "Count: " + _toDisplayString(_unref(wom).filteredWebOrdersCount.value), 1),
          _createElementVNode("p", _hoisted_18, "Value: " + _toDisplayString(_unref(formatCurrency)(_unref(wom).filteredWebOrdersValue.value)), 1)
        ])
      ])
    ]),
    (_unref(wom).selectedWebOrder.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "slideOutModal-backdrop",
          onClick: closeSlideOutModal,
          style: _normalizeStyle({ cursor: isUIBusy.value ? 'wait' : 'default' })
        }, [
          _createElementVNode("div", {
            class: "slideOutModal-container",
            onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("p", _hoisted_20, [
                _cache[20] || (_cache[20] = _createTextVNode(" Web Order: ", -1)),
                _createElementVNode("a", {
                  href: '#',
                  onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
                }, _toDisplayString(_unref(wom).selectedWebOrder.value.id), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _cache[21] || (_cache[21] = _createElementVNode("p", { class: "field-header" }, "Customer:", -1)),
              _createElementVNode("p", null, _toDisplayString(_unref(wom).selectedWebOrder.value.company || _unref(wom).selectedWebOrder.value.customerName), 1),
              _cache[22] || (_cache[22] = _createElementVNode("p", { class: "field-header" }, "Total Value:", -1)),
              _createElementVNode("p", null, _toDisplayString(_unref(formatCurrency)(_unref(wom).selectedWebOrder.value.total)), 1),
              _cache[23] || (_cache[23] = _createElementVNode("label", {
                for: "baid",
                class: "field-header"
              }, "BAID:", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "baid",
                class: "modal",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((baid).value = $event)),
                disabled: isUIBusy.value
              }, null, 8, _hoisted_22), [
                [_vModelText, baid.value]
              ]),
              _cache[24] || (_cache[24] = _createElementVNode("label", {
                for: "po",
                class: "field-header"
              }, "PO Number:", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "po",
                class: "modal",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((poNumber).value = $event)),
                disabled: isUIBusy.value
              }, null, 8, _hoisted_23), [
                [_vModelText, poNumber.value]
              ]),
              _cache[25] || (_cache[25] = _createElementVNode("label", {
                for: "desc",
                class: "field-header"
              }, "Description:", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "desc",
                class: "modal",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((salesOrderDescription).value = $event)),
                disabled: isUIBusy.value
              }, null, 8, _hoisted_24), [
                [_vModelText, salesOrderDescription.value]
              ]),
              _cache[26] || (_cache[26] = _createElementVNode("label", {
                for: "notes",
                class: "field-header"
              }, "Qteedy Notes:", -1)),
              _createElementVNode("textarea", {
                id: "notes",
                disabled: "",
                value: _unref(wom).selectedWebOrder.value.notes ?? '',
                style: _normalizeStyle({ cursor: isUIBusy.value ? 'wait' : 'text' })
              }, null, 12, _hoisted_25)
            ]),
            _cache[30] || (_cache[30] = _createElementVNode("p", { class: "field-header fira" }, "Items:", -1)),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("table", _hoisted_27, [
                _cache[28] || (_cache[28] = _createElementVNode("colgroup", null, [
                  _createElementVNode("col", { style: {"width":"62%"} }),
                  _createElementVNode("col", { style: {"width":"15%"} }),
                  _createElementVNode("col", { style: {"width":"23%"} })
                ], -1)),
                _cache[29] || (_cache[29] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Inventory ID"),
                    _createElementVNode("th", null, "Qty"),
                    _createElementVNode("th", null, "Disc (%)")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wom).selectedWebOrder.value.lineItems, (item) => {
                    return (_openBlock(), _createElementBlock("tr", { key: item }, [
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(item.inventoryId), 1),
                        _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("span", _hoisted_28, _toDisplayString(item.variantTitle), 1)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.quantity), 1),
                      _createElementVNode("td", null, _toDisplayString(Math.round(item.discountPercent * 10) / 10), 1)
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("button", {
                disabled: isUIBusy.value,
                class: "light",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (createSO()))
              }, "Create SO", 8, _hoisted_30),
              _createElementVNode("button", {
                disabled: isUIBusy.value,
                class: "light",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(wom).clearSelectedWebOrder()))
              }, "Close", 8, _hoisted_31)
            ])
          ])
        ], 4))
      : _createCommentVNode("", true),
    (displayLoginForm.value)
      ? (_openBlock(), _createBlock(AcumaticaLoginModal, {
          key: 1,
          isUIBusy: isUIBusy.value,
          loginOperation: loginOperation.value,
          onExit: closeLoginForm,
          onCredentials: _cache[12] || (_cache[12] = (username, password) => loginToAC(username, password))
        }, null, 8, ["isUIBusy", "loginOperation"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})